import React from "react";
import { Drawer, Typography, Grid } from "@mui/material";
import { CustomButton } from "../../../../common/components";
import styles from "./UserDrawer.module.css";
import { translate } from "../../../../common/providers";

export default function UserDrawer({ open, closeDrawer, childrens, onclick, title, disabled, hiddenAction }) {
	return (
		<div>
			<Drawer anchor="right" open={open} onClose={closeDrawer}>
				<Grid container className={styles.drawer}>
					<Grid item className={styles.drawerTitle} md={12}>
						<Typography>{title}</Typography>
					</Grid>
					<Grid item className={styles.drawerChildren} md={12}>
						{childrens}
					</Grid>
					<Grid className={styles.drawerFooter}>
						<CustomButton color="secondary" variant="outlined" onClick={closeDrawer}>
							{translate("common:btn.close")}
						</CustomButton>
						{!hiddenAction && (
							<CustomButton
								disabled={disabled}
								variant="contained"
								onClick={typeof onclick === "function" ? onclick : null}
							>
								{translate("common:btn.submit")}
							</CustomButton>
						)}
					</Grid>
				</Grid>
			</Drawer>
		</div>
	);
}
